<template>
  <div class="base-table-wrap">
    <el-table
      :data="data"
      :border="border"
      :stripe="stripe"
      :loading="loading"
      v-bind="$attrs"
      style="width:100%;flex:1;min-height:0;"
    >
      <el-table-column
        v-if="showIndex"
        type="index"
        label="序号"
        width="60"
        align="center"
      />
      <el-table-column
        v-for="col in columns"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
        :min-width="col.minWidth"
        :align="col.align || 'left'"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.tooltip !== false"
      >
        <template v-if="col.slot" #default="scope">
          <slot :name="col.slot" :row="scope.row" :index="scope.$index" />
        </template>
      </el-table-column>
    </el-table>

    <div v-if="total > 0" class="base-table__pagination">
      <span class="pager-info">
        显示 <span class="pager-num">{{ pageStart }}</span> 到 <span class="pager-num">{{ pageEnd }}</span> 条，共 <span class="pager-num">{{ total }}</span> 条记录
      </span>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        layout="sizes, prev, pager, next, jumper"
        @size-change="$emit('size-change', $event)"
        @current-change="$emit('page-change', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseTable',
  inheritAttrs: false,
  props: {
    data:        { type: Array,   default: () => [] },
    columns:     { type: Array,   default: () => [] },
    total:       { type: Number,  default: 0 },
    currentPage: { type: Number,  default: 1 },
    pageSize:    { type: Number,  default: 10 },
    loading:     { type: Boolean, default: false },
    border:      { type: Boolean, default: false },
    stripe:      { type: Boolean, default: true },
    showIndex:   { type: Boolean, default: true }
  },
  computed: {
    pageStart() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    pageEnd() {
      return Math.min(this.currentPage * this.pageSize, this.total)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-table-wrap {
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.base-table__pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-top: 1px solid #F0F2F5;
  padding: 16px 24px;
  flex-shrink: 0;
}

.base-table__pagination > * + * {
  margin-left: 16px;
}

.pager-info {
  font-size: 13px;
  color: #909399;
}

.pager-num {
  color: #1D5DFE;
}

::v-deep .el-pagination .el-pager li { color: #606266; }
::v-deep .el-pagination .el-pager li.active { color: #1D5DFE; font-weight: 700; }
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: transparent;
  border-color: transparent;
  color: #1D5DFE;
  font-weight: 700;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover { color: #1D5DFE; }
::v-deep .el-pagination .btn-prev:hover,
::v-deep .el-pagination .btn-next:hover { color: #1D5DFE; }
</style>
